module.exports = __webpack_public_path__ + "media/images/icon/breadcrumb/top-b068d53576e33cb3ca8cf759b5e4cd4a.png";